import { render, staticRenderFns } from "./EditCompanyInfo.vue?vue&type=template&id=07b8bf46"
import script from "./EditCompanyInfo.vue?vue&type=script&lang=js"
export * from "./EditCompanyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports